import { Component, OnInit } from '@angular/core';
import {FormGroup} from '@angular/forms';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {MatOptionSelectionChange} from '@angular/material/core';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {HADSResults, Q_HADS} from '../../../../model/questionnaires/questionnaire-hads';

@Component({
  selector: 'app-questionnaire-hads',
  templateUrl: './questionnaire-hads.component.html',
  styleUrls: ['./questionnaire-hads.component.css']
})
export class QuestionnaireHadsComponent implements OnInit {

  qForm: FormGroup;
  dataSource = Q_HADS;
  notFocused = false;
  submitted = false;
  show = false;
  displayedColumns = ['position', 'question', 'value'];
  results = [];
  q = 'question';
  found = false;
  finalScore = 0;

  /// toolbar
  back = true;
  destination = '/questionnaires';
  title = 'HADS';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;

  constructor(private questionnaireService: QuestionnaireService,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.dataSource.length; ++i) {
      this.results.push(null);
    }

    this.qForm = new FormGroup({});

    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
  }

  onSubmit(value: any) {
    this.submitted = true;
    this.show = true;
    this.found = false;

    if (this.results.length !== this.dataSource.length) {
      this.show = false;
      this.submitted = false;
      this.found = true;
      const msg = 'Non hai finito di completare il questionario!';
      this.openErrorDialog(msg);
    } else {
      for (const r of this.results) {
        if (r === null) {
          this.show = false;
          this.submitted = false;
          this.found = true;
          const msg = 'Non hai finito di completare il questionario!';
          this.openErrorDialog(msg);
          break;
        }
      }

      if (!this.found) {
        console.log(this.finalScore);
        const resultToSend = new HADSResults(this.doctorID, this.patientSSN, this.results, this.finalScore);
        this.questionnaireService.sendForm(resultToSend, 'hads', this.uuid);
      }
    }
  }

  selectResult($event: MatOptionSelectionChange, value: string, position: number, answers: string[]) {
    if ($event.isUserInput) {
      if (position === 2 || position === 4 || position === 6 || position === 8 ||
        position === 10 || position === 12 || position === 14) {
        if (this.results[position - 1] !== null) {
          let dec = 0;
          answers.forEach(answer => {
            if (answer === this.results[position - 1]) {
              this.finalScore -= dec;
              console.log('Final Score After:', this.finalScore);
            }
            dec++;
          });
        }
        let inc = 0;
        answers.forEach(answer => {
          if (answer === value) {
            this.finalScore += inc;
          }
          inc++;
        });
      } else if (position === 1 || position === 3 || position === 5 || position === 7 ||
        position === 9 || position === 11 || position === 13) {
        if (this.results[position - 1] !== null) {
          let dec = answers.length - 1;
          answers.forEach(answer => {
            if (answer === this.results[position - 1]) {
              this.finalScore -= dec;
              console.log('Final Score After:', this.finalScore);
            }
            dec--;
          });
        }
        let inc = answers.length - 1;
        answers.forEach(answer => {
          if (answer === value) {
            this.finalScore += inc;
          }
          inc--;
        });
      }
      console.log('Final Score Value set:', this.finalScore);
      this.results[position - 1] = value;
      console.log(this.results);
    }
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }

}
